export { default } from './CollectionTile';
